<template lang="pug">
  label.togglebox(:class="{disabled: disabled}")
    input(
      type="checkbox",
      v-model="value",
      :disabled="disabled",
      @change="valueChanged")
    i
    slot
</template>

<script>
export default {
  name: 'toggle-box',
  props: {
    checked: {
      type: [Boolean, Number],
      default: false
    },
    field: {
      type: [String, Number],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    restore (value) {
      this.value = value
    },
    valueChanged () {
      if (this.disabled) return
      if (this.field !== null) this.$emit('input', this.field, this.value, this.restore)
      else this.$emit('input', this.value, this.restore)
    }
  },
  watch: {
    checked (n, o) {
      if (n !== undefined && n !== o) this.value = n
    }
  },
  created () {
    if (this.checked !== undefined) this.value = this.checked
  },
  data () {
    return {
      value: false
    }
  }
}
</script>

<style lang="scss" scoped>
.togglebox {
  padding-left: 20px;
  margin: 0;
  cursor: pointer;

  input {
    position: absolute;
    margin-left: -20px;
    opacity: 0;

    &:checked {
      + i {
        border-color: #0073BB;
        &:before {
          top: 4px;
          left: 4px;
          width: 10px;
          height: 10px;
          background-color: #0073BB;
        }
      }
    }
  }

  > i {
    position: relative;
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-top: -2px;
    margin-right: 4px;
    margin-left: -20px;
    line-height: 1;
    vertical-align: middle;
    background-color: #fff;
    border: 1px solid #cfdadd;

    &:before {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 0;
      height: 0;
      background-color: transparent;
      content: "";
      -webkit-transition: all .2s;
      transition: all .2s;
    }
  }

  &.disabled > i {
    border-color: #d7d7d7 !important;
    &:before {
      background-color: #d7d7d7 !important;
    }
  }
}
</style>
